import React from 'react';
import styled from 'styled-components';
import Page from '../components/Page';
import { translate } from 'react-switch-lang';
import XingLogo from '../assets/xing.png';

// STYLES
const XingImage = styled.img`
  width: 64px;
  height: 59px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0;
    padding-right: 20%;
    font-weight: bold;
  }
`;

// COMPONENT
const Home = props => {
  
  const { data } = props;
  
  return (
    <Page title="Home">
      <img src={ process.env.REACT_APP_ROOT + data.image.path } alt="Sprech Box" />
    </Page>
  );
};

export default Home;